import { analytics } from '@app/index';
import { getPageTrackingData } from '@app/utils';
import { TRACKING_EVENTS } from '@app/constants';

const noteFormSubmitHandler = (
  e: MouseEvent,
  feedbackForm: HTMLFormElement,
  noteFormEl: HTMLElement,
  writeFeedbackEl: HTMLButtonElement
) => {
  e.preventDefault();

  const formSubmitActiveButtonEl = feedbackForm.querySelector(
    '.md-feedback__button.active'
  ) as HTMLButtonElement;
  const noteFormTextareaEl = noteFormEl.querySelector(
    'textarea'
  ) as HTMLTextAreaElement;

  const data = formSubmitActiveButtonEl.getAttribute('data-md-value');

  analytics.track(TRACKING_EVENTS.buttonClick, {
    ...getPageTrackingData(),
    button_name: 'Feedback Button',
    evaluation: data,
    data: noteFormTextareaEl.value,
  });

  noteFormEl.hidden = true;
  writeFeedbackEl.hidden = true;
};

const formSubmitHandler = (
  el: HTMLButtonElement,
  feedbackForm: HTMLFormElement,
  noteFormEl: HTMLElement,
  formFieldsetEl: HTMLFieldSetElement
) => {
  el.classList.add('active');

  const data = el.getAttribute('data-md-value');

  const noteEl = feedbackForm.querySelector(
    '.md-feedback__note'
  ) as HTMLElement;

  noteEl.hidden = true;
  noteFormEl.hidden = false;
  noteFormEl.classList.add(`data-${data}`);

  setTimeout(() => {
    formFieldsetEl.disabled = false;
    formFieldsetEl.classList.add('disabled');
  }, 0);
};

export const initFeedbackForm = () => {
  const feedbackForm = document.forms.namedItem('feedback');

  if (!feedbackForm) {
    return;
  }

  feedbackForm.hidden = false;

  const formSubmitButtonEls = feedbackForm.querySelectorAll(
    '.md-feedback__button'
  ) as NodeListOf<HTMLButtonElement>;
  const formFieldsetEl = feedbackForm.querySelector(
    'fieldset'
  ) as HTMLFieldSetElement;
  const noteFormEl = feedbackForm.querySelector(
    '.feedback-note-form'
  ) as HTMLElement;
  const noteFormSubmitEl = noteFormEl.querySelector(
    '.note-form-submit-button'
  ) as HTMLElement;
  const noteFormCancelEl = noteFormEl.querySelector(
    '.note-form-cancel-button'
  ) as HTMLElement;
  const writeFeedbackEl = feedbackForm.querySelector(
    '.write-feedback'
  ) as HTMLButtonElement;

  noteFormSubmitEl.addEventListener('click', (e) =>
    noteFormSubmitHandler(e, feedbackForm, noteFormEl, writeFeedbackEl)
  );

  noteFormCancelEl.addEventListener('click', (e) => {
    e.preventDefault();

    noteFormEl.hidden = true;
    writeFeedbackEl.hidden = false;
  });

  writeFeedbackEl.addEventListener('click', (e) => {
    e.preventDefault();

    noteFormEl.hidden = false;
  });

  formSubmitButtonEls.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      formSubmitHandler(el, feedbackForm, noteFormEl, formFieldsetEl);
    });
  });
};
